import axios from "axios"

import { 
    PASARGADREPORT_LIST_REQUEST,
    PASARGADREPORT_LIST_SUCCESS,
    PASARGADREPORT_LIST_FAIL,

    PASARGADINQUIRY_LIST_REQUEST,
    PASARGADINQUIRY_LIST_SUCCESS,
    PASARGADINQUIRY_LIST_FAIL
    
  } from "../constants/pasargadreportConstansts"

import { BASE_URL } from '../constants/urlConstants'

import axiosInstance from "../utils/axiosInstance"

  export const fetchPasargadReport = (id, startDate = '', endDate = '') => async (dispatch) => {
  try {
    dispatch({ type: PASARGADREPORT_LIST_REQUEST });
    
    // ساخت URL با کوئری استرینگ
    const { data } = await axios.get(`${BASE_URL}/pasargadReport/${id}`, {
      params: { start_date: startDate, end_date: endDate }
    });
    
    dispatch({ type: PASARGADREPORT_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PASARGADREPORT_LIST_FAIL, payload:
       error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message, });
  }
};

  // export const fetchPasargadReport = (id) => async(dispatch) => {
  //   try{
  //       dispatch({type: PASARGADREPORT_LIST_REQUEST})

  //       const { data } = await axios.get(`${BASE_URL}/pasargadReport/${id}`)
  //       dispatch({type: PASARGADREPORT_LIST_SUCCESS , payload: data})

  //   }catch(error){
  //       dispatch({type: PASARGADREPORT_LIST_FAIL,
  //           payload: error.response && error.response.data.message
  //               ? error.response.data.message
  //               : error.message
  //       })

  //   }

  // }


 
  export const fetchinquiryPasargad = (payInq) => async(dispatch) => {
    try{
        dispatch({type: PASARGADINQUIRY_LIST_REQUEST})

        const { data } = await axios.post(`${BASE_URL}/pasargadReport/inquiry/`,
        {'pk':payInq})
        dispatch({type: PASARGADINQUIRY_LIST_SUCCESS , payload: data})

    }catch(error){
        dispatch({type: PASARGADINQUIRY_LIST_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message
        })

    }

  }
  
  

  
  
  
  
  
  

  

  



